import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from 'moment';

import MenuDescargas from "../../../MenuDescargas";
import { desgloseOrdenCompra } from "../../../desgloseOC";
import { exportaExcelConFotoOpcional } from "../../../excelConFotos";
import EmbarcarOCModal from "../../../EmbarcarOCModal";
import EditarOrdenCompra from "./EditarOrdenCompra";
import SubirPIModal from "./SubirPIModal";
import { folioVendedor } from "../../../folioVendedor";
import { descargaPorTallaColor } from "../../../descargaVariantes";

function ListadoOrdenesCompra() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-91);

 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [ordenesCompra, setOrdenesCompra] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [artOC, setArtOC] = useState([]);

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedFechaCompInicio, setSelectedFechaCompInicio] = useState("");
  const [selectedFechaCompFin, setSelectedFechaCompFin] = useState("");

  
  const [totalTotalPiezas, setTotalTotalPiezas] = useState(0);
  const [totalTotalDinero, setTotalTotalDinero] = useState(0);

  // se embarca desde aqui mismo, sin ir a otra pantalla
  const [modalEmbarcar, setModalEmbarcar] = useState(false);
  const [ordenEmbarcar, setOrdenEmbarcar] = useState(null);
  // orden abierta en el editor (datos y articulos en una sola pantalla)
  const [ordenEditar, setOrdenEditar] = useState(null);
  // orden a la que se le sube la PI del proveedor
  const [ordenPI, setOrdenPI] = useState(null);
  const [coloresCat, setColoresCat] = useState([]);
  const [tallasCat, setTallasCat] = useState([]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [status, setStatus] = useState("Abierto");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_URL_COLORES, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setColoresCat(res.data.filter((a) => a.is_active === "Si")))
      .catch((err) => console.log(err));
    axios
      .get(process.env.REACT_APP_URL_TALLAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setTallasCat(res.data.filter((a) => a.is_active === "Si")))
      .catch((err) => console.log(err));
  }, []);


  useMemo(() => {
    axios
      .get(`${URL_ORDENES_COMPRA}FechasStatus/${selectedFechaInicio}/${selectedFechaFin}/${status}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allOrdenes = response.data;
        // Array para pagination
        let arrayTabla = allOrdenes
          .sort((a, b) => (a.idOrdenCompra < b.idOrdenCompra ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idOrdenCompra,
              activo: a.is_active,
              fecha: a.fecha,
              plazo: a.plazo,
              fecha_compromiso: a.fecha_compromiso,
              observaciones: a.observaciones,
              total_general: a.total_general,
              proveedores: a.proveedores?.[0]?.nombre_comercial,
              idProveedores: a.proveedores?.[0]?._id,
              total_cantidad: a.total_cantidad,
              status: a.status,
              embarcado: a.embarcado,
              moneda: a.moneda,
              folioProveedor: a.folioProveedor,
              pi: a.pi,
              fechaPi: a.fechaPi,
              cantidadOriginal: a.cantidadOriginal ?? "",
              // la OC hereda el vendedor del pedido del que nacio
              vendedor: [a.colaboradores?.[0]?.nombre, a.colaboradores?.[0]?.apellido].filter((x) => x && x !== "NA").join(" "),
              consecutivoVendedor: a.consecutivoVendedor || "",
              // pedido del que nacio la OC, con el consecutivo del vendedor de ese pedido
              pedido: parseFloat(a.pedidos?.[0]?.idPedido) || "",
              pedidoTexto: [a.pedidos?.[0]?.idPedido, folioVendedor(`${a.colaboradores?.[0]?.nombre || ""} ${a.colaboradores?.[0]?.apellido || ""}`, a.pedidos?.[0]?.consecutivoVendedor, a.pedidos?.[0]?.divisionNumero)].filter(Boolean).join(" · "),
              folioVendedor: folioVendedor(`${a.colaboradores?.[0]?.nombre || ""} ${a.colaboradores?.[0]?.apellido || ""}`, a.consecutivoVendedor),
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setOrdenesCompra(allOrdenes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(URL_PROVEEDORES, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin, status]);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.status,
          a.numero,
          a.fecha,
          a.proveedores,
          a.observaciones,
          a.total_cantidad,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general) + " " + a.moneda,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 30, 30);
    doc.text(`Listado PO`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
    });
    doc.save(`Ordenes-Compra.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return {
          Status: a.status,
          Numero: a.numero,
          Fecha: a.fecha,
          Proveedor: a.proveedor,
          Observaciones: a.observaciones,
          Cantidad: a.total_cantidad,
          Total: a.total_general,
          Moneda: a.moneda
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoOrdenesCompra";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoOrdenesCompra",
        sheetFilter: [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
          "Moneda",
        ],
        sheetHeader: [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
          "Moneda",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.status,
          a.numero,
          a.fecha,
          a.proveedores,
          a.observaciones,
          a.total_cantidad,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general) + " " + a.moneda,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 30, 30);
    doc.text(`Listado PO`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Compra",
          email: mailTo,
          fileName: "ListadoOrdenesCompra.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de PO.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  // El PDF de la orden va por ARTICULO: su foto, el total de piezas y como se
  // reparten entre colores y tallas. Las fotos se bajan antes de dibujar.
  async function PDFOC(
    fecha,
    plazo,
    folioProveedor,
    fecha_compromiso,
    idProveedores,
    proveedores,
    total_cantidad,
    total_general,
    moneda,
    observaciones,
    numero,
    idPDFOC,
  ) {
    try {
      Swal.fire({ title: "Armando el PDF", html: "Bajando las fotos de los modelos...", allowOutsideClick: false, onBeforeOpen: () => Swal.showLoading() });
      const articulos = await desgloseOrdenCompra(idPDFOC, { conFoto: true });
      Swal.close();
      if (!articulos.length) {
        Swal.fire({ icon: "info", title: "Sin renglones", text: "Esta orden no tiene articulos." });
        return;
      }
      const fmt = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);
      const piezas = articulos.reduce((s, a) => s + a.piezas, 0);
      const importe = articulos.reduce((s, a) => s + a.total, 0);

      // El documento va para el proveedor (China), asi que va en ingles.
      const doc = new jsPDF("landscape", "mm", "a4", true);
      const logo = new Image();
      logo.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      doc.addImage(logo, "png", 240, 8, 28, 28);
      doc.setFontSize(16);
      doc.text(`Purchase Order # ${numero}`, 14, 18);
      doc.setFontSize(10);
      doc.text(`Date ${fecha}   Supplier ${proveedores}`, 14, 25);
      doc.text(`Terms ${plazo} days   Delivery date ${fecha_compromiso || "NA"}   Supplier ref. ${folioProveedor || "NA"}`, 14, 30);
      doc.text(`Total pieces ${fmt(piezas)}   Amount $${fmt(importe)} ${moneda || ""}`, 14, 35);
      if (observaciones && observaciones !== "NA") doc.text(`Remarks: ${observaciones}`, 14, 40);

      const cuerpo = articulos.map((a) => ([
        "",
        `${a.codigo} ${a.nombre}`,
        a.colColores,
        a.colPiezasColor,
        a.proporcionColores,
        a.colTallas,
        a.colPiezasTalla,
        a.proporcionTallas,
        fmt(a.piezas),
        "$" + fmt(a.precio),
        "$" + fmt(a.total),
      ]));

      doc.autoTable({
        head: [["Photo", "Item", "Color", "Qty / color", "Color ratio", "Size", "Qty / size", "Size ratio", "Total qty", "Unit cost", "Amount"]],
        body: cuerpo,
        startY: 45,
        theme: "grid",
        headStyles: { fillColor: ["#f28029"], lineWidth: 0 },
        footStyles: { fillColor: ["#f28029"] },
        styles: { fontSize: 8, cellPadding: 2, valign: "middle" },
        columnStyles: {
          0: { cellWidth: 20, minCellHeight: 20 },
          2: { cellWidth: 34 },
          3: { cellWidth: 17, halign: "right" },
          4: { cellWidth: 18, halign: "center" },
          5: { cellWidth: 22 },
          6: { cellWidth: 17, halign: "right" },
          7: { cellWidth: 18, halign: "center" },
          8: { halign: "right" }, 9: { halign: "right" }, 10: { halign: "right" },
        },
        foot: [["", "", "", "", "", "", "", "Total", fmt(piezas), "", "$" + fmt(importe) + " " + (moneda || "")]],
        showFoot: "lastPage",
        didDrawCell: (data) => {
          if (data.section !== "body" || data.column.index !== 0) return;
          const a = articulos[data.row.index];
          if (!a || !a.foto) return;
          const lado = Math.min(data.cell.width, data.cell.height) - 2;
          try {
            doc.addImage(a.foto, data.cell.x + 1, data.cell.y + 1, lado, lado);
          } catch (e) { /* si la foto no se pudo leer, el renglon va sin ella */ }
        },
      });
      doc.save(`PO-${numero}.pdf`);
    } catch (error) {
      Swal.close();
      Swal.fire({ icon: "error", title: "No se pudo armar el PDF", text: error.message });
    }
  }

  // El mismo desglose, pero en Excel
  async function ExcelOC(numero, idPDFOC, proveedores, fecha) {
    try {
      Swal.fire({ title: "Armando el Excel", html: "Un momento...", allowOutsideClick: false, onBeforeOpen: () => Swal.showLoading() });
      const articulos = await desgloseOrdenCompra(idPDFOC, { conFoto: false });
      Swal.close();
      if (!articulos.length) {
        Swal.fire({ icon: "info", title: "Sin renglones", text: "Esta orden no tiene articulos." });
        return;
      }
      // una hoja con el resumen por articulo y otra con el renglon por variante
      // El Excel acompana al PDF, asi que tambien va en ingles. Siempre lleva la
      // foto: en el resumen la del modelo, en el detalle la del color si tiene.
      const resumen = articulos.map((a) => ({
        _idArticulo: a.articulos,
        "PO": numero, Date: fecha, Supplier: proveedores,
        Code: a.codigo, Item: a.nombre,
        Color: a.colores.join(" | "), "Color ratio": a.proporcionColores, "Qty by color": a.desglose,
        Size: a.tallas.join(" | "), "Size ratio": a.proporcionTallas, "Qty by size": a.desgloseTallas,
        "Total qty": a.piezas, "Unit cost": a.precio, Amount: a.total,
      }));
      const detalle = [];
      articulos.forEach((a) => a.variantes.forEach((v) => detalle.push({
        _idArticulo: a.articulos, _idColor: v.idColor,
        "PO": numero, Code: a.codigo, Item: a.nombre,
        Color: v.colorNombre, Size: v.talla, Qty: v.cantidad,
        "Unit cost": a.precio, Amount: v.cantidad * a.precio,
      })));
      const columnas = (f) => Object.keys(f).filter((k) => !k.startsWith("_"));
      await exportaExcelConFotoOpcional({
        nombreArchivo: `PO-${numero}`,
        siempreConFoto: true,
        hojas: [
          { nombre: "By item", filas: resumen, columnas: columnas(resumen[0]) },
          { nombre: "By color and size", filas: detalle, columnas: columnas(detalle[0]) },
        ],
      });
    } catch (error) {
      Swal.close();
      Swal.fire({ icon: "error", title: "No se pudo armar el Excel", text: error.message });
    }
  }

  // async function ExcelOCMigracion(
  //   numero,
  //   idPDFOC
  // ) {
  //   await axios
  //     .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosOrden = response.data;
  //       let arrayTabla = allArticulosOrden
  //         .map((a) => {
  //           return {
  //             articulosOrden: a._id,
  //             articulos: a.articulos?.[0]?._id,
  //             cantidad: a.cantidad,
  //             cantidadOC: a.cantidad,
  //             costo: a.precio
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });

  //       let dataFinal = Object.values(arrayTabla);

  //       var option = {};
  
  //       option.fileName = `OC-${numero}`;
    
  //       option.datas = [
  //         {
  //           sheetData: dataFinal,
  //           sheetName: `OC-${numero}`,
  //           sheetFilter: [
  //             "articulosOrden",
  //             "articulos",
  //             "cantidad",
  //             "cantidadOC",
  //             "costo",
  //           ],
  //           sheetHeader: [
  //             "articulosOrden",
  //             "articulos",
  //             "cantidad",
  //             "cantidadOC",
  //             "costo",
  //           ],
  //         },
  //       ];
    
  //       var toExcel = new ExportJsonExcel(option);
  //       toExcel.saveExcel();
       
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Pedido", field: "pedido", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Consecutivo Vendedor", field: "consecutivoVendedor", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Folio Proveedor", field: "folioProveedor", sortable: false },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Fecha Compromiso", field: "fecha_compromiso", sortable: true },
    { name: "Proveedor", field: "proveedores", sortable: true },
    { name: "Cantidad Original", field: "cantidadOriginal", sortable: true },
    { name: "Cantidad", field: "total_cantidad", sortable: true },
    { name: "Embarcado", field: "embarcado", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Moneda", field: "moneda", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.observaciones ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.folioProveedor ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.proveedores ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.vendedor ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.pedidoTexto ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.folioVendedor ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.moneda ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.total_cantidad ?? "").toString().includes(search) ||
          String(comment.embarcado ?? "").toString().includes(search) ||
          String(comment.total_general ?? "").toString().includes(search) ||
          String(comment.numero ?? "").toString().includes(search)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        String(e.idProveedores ?? "").includes(selectedProveedor)
      );
    }
    if (status) {
      computedComments = computedComments.filter((e) =>
        String(e.status ?? "").includes(status)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    if (selectedFechaCompInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso >= selectedFechaCompInicio
      );
    }

    if (selectedFechaCompFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso <= selectedFechaCompFin
      );
    }

    let car = computedComments.map((c) => parseFloat(c.total_cantidad));
    let TCar = car.reduce((t, total_cantidad, index) => t + total_cantidad, 0);
    setTotalTotalPiezas(TCar);

    let din = computedComments.map((c) => parseFloat(c.total_general));
    let TDin = din.reduce((t, total_general, index) => t + total_general, 0);
    setTotalTotalDinero(TDin);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      sorting.field != "embarcado" &&
      sorting.field != "total_general" &&
      sorting.field != "numero" &&
      sorting.field != "consecutivoVendedor" &&
      sorting.field != "pedido" &&
      sorting.field != "cantidadOriginal"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "embarcado" ||
        sorting.field == "total_general" ||
        sorting.field == "numero" ||
        sorting.field == "consecutivoVendedor" ||
        sorting.field == "pedido" ||
        sorting.field == "cantidadOriginal")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "embarcado" ||
        sorting.field == "total_general" ||
        sorting.field == "numero" ||
        sorting.field == "consecutivoVendedor" ||
        sorting.field == "pedido" ||
        sorting.field == "cantidadOriginal")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    status,
    selectedFechaInicio,
    selectedFechaFin,
    selectedProveedor,
  ]);

  // Catalogo de articulos ordenado y sus <option> memoizados: se calcula una
  // sola vez (y no en cada render ni por cada renglon). Antes se hacia
  // articulos.sort().map() dentro de cada linea -> con 4600 articulos x cientos
  // de lineas el modal se congelaba.
  function excelInfoArt() {

    axios
    .get(`${URL_ARTICULOS_OC}FindAllInfoArt`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allInfoArt = response.data;

      const dataExcel = allInfoArt.map((a) => {
          return {
            Articulo: a.nombre,
            Cantidad: a.cantidad,
            Embarcado: a.embarcado,
            PendienteEmbarcar: a.pendiente_embarcar,
          };
      });
      const dataExportExcel = Object.values(dataExcel);
      const dataExcelLimpia = dataExportExcel.filter(function (el) {
        return el != null;
      });
  
      var option = {};
  
      option.fileName = "Info Articulos OC";
  
      option.datas = [
        {
          sheetData: dataExcelLimpia,
          sheetName: "Info Articulos OC",
          sheetFilter: [
            "Articulo",
            "Cantidad",
            "Embarcado",
            "PendienteEmbarcar",
          ],
          sheetHeader: [
            "Articulo",
            "Cantidad",
            "Embarcado",
            "PendienteEmbarcar",
          ],
        },
      ];
  
      var toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();

    })
    .catch((err) => {
      console.log(err);
    });

  
  }


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras && ordenEditar ? (
        <EditarOrdenCompra
          orden={ordenEditar}
          articulos={articulos}
          coloresCat={coloresCat}
          tallasCat={tallasCat}
          proveedores={proveedores}
          user={user}
          onRegresar={() => setOrdenEditar(null)}
        />
      ) : user.menu_compras ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.menu_compras ? (
                <Button title="Capturar una orden de compra nueva"
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCompraCreate"
                >
                  Nueva Orden
                </Button>
              ) : (
                <Button title="Capturar una orden de compra nueva"
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Orden
                </Button>
              )}
              <Button title="Volver al menú"
                size="sm"
                href="/MenuOperacion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4} className="text-right">
              <MenuDescargas
                    opciones={[
                      { label: "PDF del listado", icon: "far fa-file-pdf", onClick: PDFTabla },
                      { label: "Excel del listado", icon: "far fa-file-excel", onClick: excel },
                      { label: "Excel info de artículos", icon: "fas fa-tshirt", onClick: excelInfoArt },
                      { label: "Excel por talla y color", icon: "fas fa-th", onClick: () => descargaPorTallaColor("ordenesCompra", "OrdenesCompraPorTallaColor") },
                      { separador: true },
                      { label: "Enviar por correo", icon: "fas fa-at", onClick: toggleMail },
                    ]}
                  />
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado PO</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button title="Enviar el listado al correo" size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">PO</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Proveedores</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {proveedores
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>

            {/* 
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Comp Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaCompInicio}
                required
                onChange={(e) => {
                  setSelectedFechaCompInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Comp Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaCompFin}
                required
                onChange={(e) => {
                  setSelectedFechaCompFin(e.target.value);
                }}
              />
            </Col> */}

            <Col md={2}>
              <Label>Status</Label>
              <Input
                bsSize="sm"
                type="select"
                value={status}
                required
                onChange={(e) => {
                  setStatus(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Abierto">Abierto</option>
                <option value="Cerrado">Cerrado</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{a.pedidoTexto}</td>
                      <td>{a.vendedor}</td>
                      <td>{a.folioVendedor}</td>
                      <td>{a.fecha}</td>
                      <td>{a.folioProveedor}</td>
                      <td>{a.observaciones}</td>
                      <td>{a.fecha_compromiso}</td>
                      <td>{a.proveedores}</td>
                      <td>{a.cantidadOriginal === "" ? "" : new Intl.NumberFormat("en-US").format(a.cantidadOriginal)}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.total_cantidad
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          a.embarcado
                        )}
                      </td>
                      <td>
                        {"$" +
                          new Intl.NumberFormat("en-US").format(
                            a.total_general
                          )}{" "}
                      </td>
                      <td>{a.moneda}</td>
                      <td>
                        {user.menu_compras ? (
                          <div>
                            <Button title="Descargar el PDF"
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.plazo,
                                  a.folioProveedor,
                                  a.fecha_compromiso,
                                  a.idProveedores,
                                  a.proveedores,
                                  a.total_cantidad,
                                  a.total_general,
                                  a.moneda,
                                  a.observaciones,
                                  a.numero,
                                  a._id
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>

                            <Button title="Descargar la orden en Excel (por articulo y por talla y color)"
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOC(a.numero, a._id, a.proveedores, a.fecha)}
                            >
                              <i class="far fa-file-excel"></i>
                            </Button>

                            {/* <Baja
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_COMPRA}
                            /> 
                             <BajaAltaMultiple
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_COMPRA}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_OC}/baja`}
                            />*/}
                            <StatusMultiple
                              idStatus={a._id}
                              status={a.status}
                              URL_STATUS={
                                process.env.REACT_APP_URL_ORDENES_COMPRA
                              }
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_OC}/baja`}
                            />
                          </div>
                        ) : undefined}
                      </td>
                      <td>
                        {a.status == "Abierto" && a.activo == "Si" ? (
                          <div>
                            <Button
                              color="success"
                              size="sm"
                              title="Embarcar lo que falta de esta orden"
                              onClick={() => { setOrdenEmbarcar(a); setModalEmbarcar(true); }}
                            >
                              <i class="fas fa-ship"></i>
                            </Button>
                            <Button title="Subir la PI del proveedor"
                              color="warning"
                              size="sm"
                              onClick={() => setOrdenPI(a)}
                            >
                              <i class="fas fa-file-upload"></i>
                            </Button>
                            <Button title="Editar la orden: datos y artículos"
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={() => setOrdenEditar(a)}
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                          </div>
                        ) : (
                          <div>
                            <Button title="Solo se editan las órdenes abiertas" color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
               <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="right">
                  TOTAL GENERAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", { maximumFractionDigits: 2}).format(totalTotalPiezas)}
                </td>
                <td className="negrita"> </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDinero)}
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

     <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>

      <SubirPIModal
        abierto={!!ordenPI}
        cerrar={() => setOrdenPI(null)}
        orden={ordenPI}
        coloresCat={coloresCat}
        tallasCat={tallasCat}
        onAplicada={() => window.location.reload()}
      />

      <EmbarcarOCModal
        abierto={modalEmbarcar}
        cerrar={() => setModalEmbarcar(false)}
        orden={ordenEmbarcar}
        user={user.id}
        onEmbarcado={() => window.location.reload()}
      />
      {loader}
    </>
  );
}

export default ListadoOrdenesCompra;
